<template>
    <div class="header-item">
        <h4 class="list-header-title font-weight-medium">
            {{ name }}
        </h4>
        <div class="header-filters">
            <list-header-sort :is-sorted-by="isSortedBy"
                              :sort-direction="sortDirection"
                              @sort="sort"
            />
        </div>
    </div>
</template>

<script>
    import { mapMutations, mapState } from 'vuex';
    import ListHeaderSort from '@/components/controls/list-sort/ListHeaderSort';

    export default {
        name: 'CompanyListHeaderItem',
        components: {ListHeaderSort},
        props: ['id', 'name'],
        computed: {
            ...mapState('companies', ['listingHeader']),
            isSortedBy() {
                return this.listingHeader.sorting.targetId === this.id;
            },
            sortDirection() {
                return this.listingHeader.sorting.direction;
            },
        },
        methods: {
            ...mapMutations('companies', ['setSortingDirection', 'setSortingTargetId']),
            sort(direction) {
                this.setSortingDirection(direction);
                this.setSortingTargetId(this.id);
            }
        }
    };
</script>

<style lang="scss"
       scoped
>
button.v-icon {
    font-size: 18px !important;
}
</style>
